import { getUrlParam, getBaseUrl, goToPassport, connectToOtherPassport} from "@/framework/utils/tools";

// initial state
const state = {
  count: 8888,
  selector: {},
  userInfo: {},
  systemConfig: {},
  loginCount: 0
};
// getters
const getters = {
  count: state => state.count,
  selector: state => state.selector,
  userInfo: state => state.userInfo,
  systemConfig: state => state.systemConfig,
  loginCount: state => state.loginCount
};
// actions
const actions = {
  addLoginCount({ commit }) {
    commit("addLoginCount")
  },
  addCount({ commit }) {
    commit("addCount");
  },
  async getSelector({ commit }) {
    const { ret, data } = await _api.customer.getMultiTypeList();
    if (ret && data) {
      commit("setSelector", data);
    }
  },
  async getSystemConfig({ commit }) {
    const { ret, data } = await _api.customer.getSystemConfig({
      v: Math.random()
    });
    if (ret && data) {
      commit("setSystemConfig", data);
    }

    // 洗掉 tickets
    if(getUrlParam("MC_ST")) {
      window.location = getBaseUrl();
    }
  },
  getUserInfo({ state, commit, dispatch }) {
      // 鉴权处理
    const { userInfo = {} } = state;

    const userData = {
      _ENV_: {
        tickets: getUrlParam("MC_ST") || userInfo.tickets
      }
    };
    return _api.site
      .getUserInfo({
        ...userData, 
        v: Math.random()
      })
      .then(res => {
        const { ret, data, error = {} } = res;
        if(ret) {
          commit("updateUserInfo", data);
          dispatch('getSystemConfig');
          try { connectToOtherPassport(userInfo._ENV_.tickets) } catch (e) {}
          return;
        }
        // 没有登录
        if([1000001, 1100001, 1100002, 1100004].indexOf(error.code) > -1 ) {
          dispatch('logout', { userData, code: error.code });
        }
      })
      .catch(goToPassport);
  },
  async logout({ commit, state }, { userData = {}, code = 0 }) {
    await _api.site.logout({
      ...state.userInfo,
      ...userData
    });

    commit("updateUserInfo", {});
    commit("setSystemConfig", {});
    $cookies.remove('purchaseGroupId', '/', '.yunshanmeicai.com');
    
    goToPassport((code===1100002) ? 5000 : 0);
  }
};
// mutations
const mutations = {
  addCount(state) {
    state.count++;
  },
  setSelector(state, payload) {
    state.selector = payload;
  },
  setSystemConfig(state, payload) {
    state.systemConfig = payload;
  },
  updateUserInfo(state, payload) {
    state.userInfo = payload;
  },
  addLoginCount(state, payload) {
    state.loginCount++;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
